import { render, staticRenderFns } from "./TaxPurpose.vue?vue&type=template&id=7c01e5dc&scoped=true&"
import script from "./TaxPurpose.vue?vue&type=script&lang=js&"
export * from "./TaxPurpose.vue?vue&type=script&lang=js&"
import style0 from "./TaxPurpose.vue?vue&type=style&index=0&id=7c01e5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01e5dc",
  null
  
)

export default component.exports